const KNOWN_EXTENSIONS = [
  "pdf",
  "png",
  "jpg",
  "jpeg",
  "webp",
  "gif",
  "mp4",
  "webm",
  "mov",
  "avi",
  "mkv",
  "m4v",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "csv",
  "ppt",
  "pptx",
];

const KNOWN_EXTENSION_PATTERN = new RegExp(
  `\\.(${KNOWN_EXTENSIONS.join("|")})(?:[^a-z0-9]|$)`,
  "i",
);

/**
 * Extract a file extension from a URL/path, including names like
 * "report.pdf (2)" / "report.pdf%20%282%29".
 */
export const getFileExtension = (urlOrPath, fallback = "file") => {
  if (!urlOrPath) {
    return fallback;
  }

  let path = String(urlOrPath);

  try {
    path = decodeURIComponent(path);
  } catch {
    // Keep the original value when decoding fails.
  }

  path = path.split("?")[0].split("#")[0];
  const fileName = path.split("/").pop() || path;

  const knownMatch = fileName.match(KNOWN_EXTENSION_PATTERN);
  if (knownMatch?.[1]) {
    return knownMatch[1].toLowerCase();
  }

  const lastDot = fileName.lastIndexOf(".");
  if (lastDot !== -1) {
    const ext = fileName.slice(lastDot + 1).toLowerCase();
    if (/^[a-z0-9]{1,5}$/.test(ext)) {
      return ext;
    }
  }

  return fallback;
};
